<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g transform="translate(-96.209 -357.209)">
      <circle
        class="a"
        :fill="color"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(96.209 357.209)"
      />
      <circle
        class="a"
        :fill="color"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(107.209 357.209)"
      />
      <circle
        class="a"
        :fill="color"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(96.209 368.209)"
      />
      <circle
        class="a"
        :fill="color"
        cx="4.5"
        cy="4.5"
        r="4.5"
        transform="translate(107.209 368.209)"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Courses_Icon',
    props: {
      color: {
        type: String,
        default: '#383935',
      },
    },
  }
</script>

<style scoped>
  svg {
    width: 20px;
    height: 20px;
  }
</style>
